import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, CreditCard, ChevronDown, Star, AlertTriangle, BookOpen, Users, TrendingUp, Globe, FileText, Lock, Zap, Briefcase } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { PricingGrid } from './PricingGrid';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/va6r5BtFzKCzsCCCAi5J9i/conjunto_de_mockups_historia.png'
};
const LINKS = {
  PACK_COMPLETO: 'https://checkout.kitonline.shop/cart/47792279060718:1',
  PACK_COMPLETO_PROYECTOS: 'https://checkout.kitonline.shop/cart/47792279388398:1'
};
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(0);
  const packLinks = [LINKS.PACK_COMPLETO, LINKS.PACK_COMPLETO_PROYECTOS];
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-white min-h-screen flex flex-col" data-id="element-41">
      <CountdownTimer data-id="element-42" />
      <SocialProofPopup data-id="element-43" />

      {/* HERO */}
      <section className="bg-black py-2 md:py-6 px-3 md:px-4 text-center" data-id="element-44">
        <div className="max-w-3xl mx-auto" data-id="element-45">
          <p className="text-[#eab308] text-[10px] md:text-xs font-black uppercase tracking-widest mb-1 md:mb-2" data-id="element-46">
            ⭐ El recurso #1 para docentes de Historia ⭐
          </p>

          <h1 className="text-xl md:text-3xl lg:text-4xl font-black text-white mb-1 md:mb-2 leading-tight uppercase" data-id="element-47">
            Dejá de perder horas preparando clases de historia
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:opacity-95 transition-opacity my-1 md:my-3" data-id="element-48">
            <img src={IMAGES.MAIN} alt="Kit Completo Historia Mockup" className="w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-49" />
          </div>

          <p className="text-sm md:text-lg text-[#eab308] font-black italic mb-1 md:mb-2 uppercase" data-id="element-50">
            Listo para usar. Sin buscar más.
          </p>

          <p className="text-xs md:text-sm text-gray-300 mb-2 md:mb-4 max-w-xl mx-auto font-medium" data-id="element-51">
            El sistema que usan los docentes de historia en Argentina para
            planificar todo el año en una tarde
          </p>

          <div className="flex justify-center gap-1 md:gap-2 mb-2 md:mb-3 flex-nowrap" data-id="element-52">
            <span className="flex items-center gap-0.5 border border-gray-600 text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-53">
              <FileText className="w-2 h-2 md:w-2.5 md:h-2.5 text-[#eab308]" data-id="element-54" />{' '}
              100% PDF
            </span>
            <span className="flex items-center gap-0.5 border border-gray-600 text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-55">
              <Zap className="w-2 h-2 md:w-2.5 md:h-2.5 text-[#eab308]" data-id="element-56" />{' '}
              Acceso inmediato
            </span>
            <span className="flex items-center gap-0.5 border border-gray-600 text-gray-300 text-[9px] md:text-[10px] px-1.5 py-0.5 md:px-2 md:py-1 rounded-full whitespace-nowrap font-bold" data-id="element-57">
              🇦🇷 Currículo argentino
            </span>
          </div>

          <button onClick={scrollToPricing} className="inline-flex items-center justify-center bg-[#eab308] hover:bg-[#ca8a04] text-black font-black text-xs md:text-base py-2 px-4 md:py-3 md:px-8 rounded-lg shadow-[0_0_20px_rgba(234,179,8,0.4)] transform hover:scale-105 transition-all duration-200 mb-1.5 md:mb-3 whitespace-nowrap uppercase" data-id="element-58">
            → QUIERO MI KIT COMPLETO AHORA
          </button>

          <div className="flex justify-center gap-1.5 md:gap-3 text-[9px] md:text-[10px] text-gray-400 font-bold flex-nowrap uppercase tracking-wider" data-id="element-59">
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-60">
              <ShieldCheck className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#eab308]" data-id="element-61" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-62">
              <Lock className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#eab308]" data-id="element-63" /> Pago
              seguro
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-64">
              <CreditCard className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#eab308]" data-id="element-65" />{' '}
              Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="bg-gray-50 py-3 md:py-6 px-4 border-t border-gray-200" data-id="element-66">
        <div className="max-w-2xl mx-auto" data-id="element-67">
          <h2 className="text-xl md:text-2xl font-black text-center text-gray-900 mb-3 md:mb-4 uppercase" data-id="element-68">
            <span className="text-red-600 underline decoration-red-600/30 decoration-4 underline-offset-2" data-id="element-69">
              ❌ ¿Te pasa esto?
            </span>
          </h2>

          <div className="space-y-1.5 md:space-y-2 text-sm md:text-base text-gray-800 font-medium leading-snug" data-id="element-70">
            <p className="flex items-start gap-1.5" data-id="element-71">
              <span className="flex-shrink-0" data-id="element-72">❌</span>
              Buscás material de historia y encontrás contenidos genéricos que
              no se adaptan a la realidad argentina
            </p>
            <p className="flex items-start gap-1.5" data-id="element-73">
              <span className="flex-shrink-0" data-id="element-74">❌</span>
              Armás actividades desde cero porque no existe material organizado
              para secundaria
            </p>
            <p className="flex items-start gap-1.5" data-id="element-75">
              <span className="flex-shrink-0" data-id="element-76">❌</span>
              Tus alumnos no se enganchan porque la historia se vuelve teórica y
              poco dinámica
            </p>
            <p className="flex items-start gap-1.5" data-id="element-77">
              <span className="flex-shrink-0" data-id="element-78">❌</span>
              Las planificaciones y evaluaciones te consumen horas que no tenés
            </p>
            <p className="flex items-start gap-1.5" data-id="element-79">
              <span className="flex-shrink-0" data-id="element-80">❌</span>
              Querés trabajar análisis de fuentes, procesos históricos y
              pensamiento crítico… pero no tenés el material estructurado
            </p>
          </div>
        </div>
      </section>

      {/* EXTRA PERSUASIVE CTA */}
      <section className="bg-white py-2 md:py-4 px-4 text-center" data-id="element-81">
        <button onClick={scrollToPricing} className="bg-[#eab308] hover:bg-[#ca8a04] text-black font-black text-sm md:text-lg py-2.5 px-4 md:py-3 md:px-6 rounded-lg shadow-[0_0_15px_rgba(234,179,8,0.3)] transform hover:scale-105 transition-all duration-200 w-full md:w-auto max-w-xl uppercase" data-id="element-82">
          🔥 ¡QUIERO DEJAR DE IMPROVISAR Y TENER TODO RESUELTO!
        </button>
      </section>

      {/* SOLUTION */}
      <section className="bg-black text-white py-4 md:py-6 px-4 text-center" data-id="element-83">
        <div className="max-w-3xl mx-auto" data-id="element-84">
          <span className="inline-block bg-[#eab308] text-black text-[10px] font-black px-2 py-0.5 rounded-full mb-1.5 md:mb-3 uppercase tracking-widest shadow-sm" data-id="element-85">
            La Solución
          </span>
          <h2 className="text-2xl md:text-4xl font-black mb-1.5 md:mb-3 uppercase" data-id="element-86">
            KIT COMPLETO{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-4" data-id="element-87">
              HISTORIA LISTA
            </span>
          </h2>
          <p className="text-sm md:text-base text-gray-300 mb-3 md:mb-5 max-w-2xl mx-auto font-medium" data-id="element-88">
            Sistema integral de clases, actividades, proyectos y evaluaciones
            diseñadas específicamente para secundaria.
          </p>

          <div className="flex flex-col items-center gap-1.5 md:gap-2 text-sm md:text-base font-bold text-white text-left max-w-xl mx-auto" data-id="element-89">
            <span className="flex items-start gap-2 w-full" data-id="element-90">
              <span className="flex-shrink-0 mt-0.5" data-id="element-91">✅</span>
              Dar clases de historia con material claro, organizado y listo para
              usar
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-92">
              <span className="flex-shrink-0 mt-0.5" data-id="element-93">✅</span>
              Tener actividades, trabajos prácticos y evaluaciones sin preparar
              nada adicional
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-94">
              <span className="flex-shrink-0 mt-0.5" data-id="element-95">✅</span>
              Cumplir con los NAP 2026 y justificar ante directivos con rúbricas
              por capacidades
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-96">
              <span className="flex-shrink-0 mt-0.5" data-id="element-97">✅</span>
              Conectar con tus alumnos usando ejemplos históricos claros, líneas
              de tiempo y análisis reales
            </span>
            <span className="flex items-start gap-2 w-full" data-id="element-98">
              <span className="flex-shrink-0 mt-0.5" data-id="element-99">✅</span>
              Ahorrar horas de trabajo cada semana
            </span>
          </div>
        </div>
      </section>

      {/* CONTENTS ACCORDION */}
      <section className="bg-white py-4 md:py-6 px-4" data-id="element-100">
        <div className="max-w-3xl mx-auto" data-id="element-101">
          <div className="text-center mb-3 md:mb-5" data-id="element-102">
            <h2 className="text-xl md:text-3xl font-black text-gray-900 mb-1 md:mb-2 uppercase" data-id="element-103">
              ¿QUÉ INCLUYE EL{' '}
              <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-2" data-id="element-104">
                KIT COMPLETO
              </span>
              ?
            </h2>
            <p className="text-sm md:text-base text-gray-800 font-black mb-1 uppercase" data-id="element-105">
              📚 360 páginas · 6 tomos · Alineado NAP 2026
            </p>
            <p className="text-[10px] md:text-xs text-gray-500 font-bold uppercase tracking-wider" data-id="element-106">
              ✅ Tocá cada cuadernillo para ver su contenido
            </p>
          </div>

          <div className="space-y-1 md:space-y-1.5" data-id="element-107">
            {/* Tomo 1 */}
            <div className="bg-gray-50 rounded-lg border-2 border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-108">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 0 ? null : 0)} className="w-full flex items-center gap-2 p-2 md:p-3 text-left cursor-pointer" data-id="element-109">
                <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-blue-600 flex-shrink-0" data-id="element-110" />
                <h3 className="text-xs md:text-sm font-black text-gray-900 flex-1 uppercase" data-id="element-111">
                  TOMO 1 — Introducción al Pensamiento Histórico
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 0 ? 'rotate-180' : ''}`} data-id="element-112" />
              </button>
              <AnimatePresence data-id="element-113">
                {openCuadernillo === 0 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-114">
                    <div className="px-3 md:px-4 pb-2 md:pb-3 border-t-2 border-gray-100 pt-2 md:pt-2" data-id="element-115">
                      <p className="text-gray-700 text-[10px] md:text-xs font-medium leading-snug" data-id="element-116">
                        Qué es la historia y para qué sirve. El rol del
                        historiador. Tipos de fuentes históricas (primarias y
                        secundarias). Interpretación de fuentes. Tiempo
                        histórico y periodización. Historiografía. Incluye:
                        análisis de documentos, actividades de interpretación,
                        ejercicios de líneas de tiempo, debates sobre versiones
                        históricas.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 2 */}
            <div className="bg-gray-50 rounded-lg border-2 border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-117">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 1 ? null : 1)} className="w-full flex items-center gap-2 p-2 md:p-3 text-left cursor-pointer" data-id="element-118">
                <TrendingUp className="w-5 h-5 md:w-6 md:h-6 text-green-600 flex-shrink-0" data-id="element-119" />
                <h3 className="text-xs md:text-sm font-black text-gray-900 flex-1 uppercase" data-id="element-120">
                  TOMO 2 — Primeras Civilizaciones
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 1 ? 'rotate-180' : ''}`} data-id="element-121" />
              </button>
              <AnimatePresence data-id="element-122">
                {openCuadernillo === 1 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-123">
                    <div className="px-3 md:px-4 pb-2 md:pb-3 border-t-2 border-gray-100 pt-2 md:pt-2" data-id="element-124">
                      <p className="text-gray-700 text-[10px] md:text-xs font-medium leading-snug" data-id="element-125">
                        Mesopotamia, Egipto, India y China. Organización social
                        y política. Religión y cultura. Economía y primeros
                        Estados. Incluye: comparación de civilizaciones,
                        análisis de códigos y leyes, actividades prácticas,
                        trabajos grupales.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 3 */}
            <div className="bg-gray-50 rounded-lg border-2 border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-126">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 2 ? null : 2)} className="w-full flex items-center gap-2 p-2 md:p-3 text-left cursor-pointer" data-id="element-127">
                <Users className="w-5 h-5 md:w-6 md:h-6 text-amber-500 flex-shrink-0" data-id="element-128" />
                <h3 className="text-xs md:text-sm font-black text-gray-900 flex-1 uppercase" data-id="element-129">
                  TOMO 3 — Mundo Antiguo Clásico
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 2 ? 'rotate-180' : ''}`} data-id="element-130" />
              </button>
              <AnimatePresence data-id="element-131">
                {openCuadernillo === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-132">
                    <div className="px-3 md:px-4 pb-2 md:pb-3 border-t-2 border-gray-100 pt-2 md:pt-2" data-id="element-133">
                      <p className="text-gray-700 text-[10px] md:text-xs font-medium leading-snug" data-id="element-134">
                        Grecia: democracia, filosofía y sociedad. Esparta vs
                        Atenas. Imperio Romano: expansión y organización.
                        Derecho romano y legado. Incluye: análisis de textos
                        clásicos, debates sobre democracia, actividades
                        comparativas.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 4 */}
            <div className="bg-gray-50 rounded-lg border-2 border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-135">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 3 ? null : 3)} className="w-full flex items-center gap-2 p-2 md:p-3 text-left cursor-pointer" data-id="element-136">
                <Globe className="w-5 h-5 md:w-6 md:h-6 text-red-600 flex-shrink-0" data-id="element-137" />
                <h3 className="text-xs md:text-sm font-black text-gray-900 flex-1 uppercase" data-id="element-138">
                  TOMO 4 — Edad Media
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 3 ? 'rotate-180' : ''}`} data-id="element-139" />
              </button>
              <AnimatePresence data-id="element-140">
                {openCuadernillo === 3 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-141">
                    <div className="px-3 md:px-4 pb-2 md:pb-3 border-t-2 border-gray-100 pt-2 md:pt-2" data-id="element-142">
                      <p className="text-gray-700 text-[10px] md:text-xs font-medium leading-snug" data-id="element-143">
                        Caída del Imperio Romano. Feudalismo y sociedad
                        medieval. Iglesia y poder. Cruzadas. Mundo islámico.
                        Incluye: análisis de mapas históricos, actividades de
                        comparación, trabajos de reflexión.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 5 */}
            <div className="bg-gray-50 rounded-lg border-2 border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-144">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 4 ? null : 4)} className="w-full flex items-center gap-2 p-2 md:p-3 text-left cursor-pointer" data-id="element-145">
                <Briefcase className="w-5 h-5 md:w-6 md:h-6 text-yellow-500 flex-shrink-0" data-id="element-146" />
                <h3 className="text-xs md:text-sm font-black text-gray-900 flex-1 uppercase" data-id="element-147">
                  TOMO 5 — Edad Moderna
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 4 ? 'rotate-180' : ''}`} data-id="element-148" />
              </button>
              <AnimatePresence data-id="element-149">
                {openCuadernillo === 4 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-150">
                    <div className="px-3 md:px-4 pb-2 md:pb-3 border-t-2 border-gray-100 pt-2 md:pt-2" data-id="element-151">
                      <p className="text-gray-700 text-[10px] md:text-xs font-medium leading-snug" data-id="element-152">
                        Renacimiento. Reforma protestante. Expansión europea.
                        Colonización. Absolutismo. Revoluciones. Incluye:
                        análisis de documentos históricos, debates políticos,
                        actividades de interpretación.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 6 */}
            <div className="bg-gray-50 rounded-lg border-2 border-gray-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-153">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 5 ? null : 5)} className="w-full flex items-center gap-2 p-2 md:p-3 text-left cursor-pointer" data-id="element-154">
                <FileText className="w-5 h-5 md:w-6 md:h-6 text-purple-600 flex-shrink-0" data-id="element-155" />
                <h3 className="text-xs md:text-sm font-black text-gray-900 flex-1 uppercase" data-id="element-156">
                  TOMO 6 — Historia Argentina y Latinoamericana
                </h3>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 5 ? 'rotate-180' : ''}`} data-id="element-157" />
              </button>
              <AnimatePresence data-id="element-158">
                {openCuadernillo === 5 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-159">
                    <div className="px-3 md:px-4 pb-2 md:pb-3 border-t-2 border-gray-100 pt-2 md:pt-2" data-id="element-160">
                      <p className="text-gray-700 text-[10px] md:text-xs font-medium leading-snug" data-id="element-161">
                        Pueblos originarios. Colonización española. Procesos de
                        independencia. Formación del Estado argentino. Siglos
                        XIX y XX. Incluye: análisis de documentos argentinos,
                        debates históricos, actividades aplicadas.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 100%)'
    }} data-id="element-162">
        <div className="max-w-4xl mx-auto" data-id="element-163">
          <div className="text-center mb-3 md:mb-5" data-id="element-164">
            <h2 className="text-xl md:text-3xl font-black text-white mb-1.5 md:mb-2 uppercase leading-tight" data-id="element-165">
              <span className="text-[#eab308]" data-id="element-166">BONUS</span> exclusivos incluidos
            </h2>

            <div className="inline-flex items-center gap-1.5 bg-red-600 text-white font-black text-[10px] md:text-xs px-3 md:px-5 py-1 md:py-1.5 rounded-lg shadow-[0_0_15px_rgba(220,38,38,0.4)] mb-3 md:mb-4 uppercase tracking-widest" data-id="element-167">
              <span className="text-sm md:text-base" data-id="element-168">🎁</span>
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-5" data-id="element-169">
            {/* Bonus 1 */}
            <div className="relative bg-[#111633] rounded-lg border-2 border-[#1e2a5a] overflow-hidden p-2.5 md:p-4 flex flex-col" data-id="element-170">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-171">
                01
              </span>
              <span className="inline-block bg-red-600 text-white text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start" data-id="element-172">
                BONO #01
              </span>
              <div className="text-2xl md:text-3xl mb-1.5" data-id="element-173">📋</div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-174">
                Planificación Anual de Historia
              </h3>
              <p className="text-gray-400 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-175">
                Planificación completa del año. Organización por unidades.
                Objetivos claros. Secuencia didáctica lista.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t-2 border-white/10" data-id="element-176">
                <span className="text-gray-500 text-[9px] md:text-[10px] line-through font-bold" data-id="element-177">
                  Valor $8.500
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest" data-id="element-178">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="relative bg-[#111633] rounded-lg border-2 border-[#1e2a5a] overflow-hidden p-2.5 md:p-4 flex flex-col" data-id="element-179">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-180">
                02
              </span>
              <span className="inline-block bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start" data-id="element-181">
                BONO #02
              </span>
              <div className="text-2xl md:text-3xl mb-1.5" data-id="element-182">📚</div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-183">
                Actividades de Historia para el Aula
              </h3>
              <p className="text-gray-400 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-184">
                Análisis de fuentes. Líneas de tiempo. Debates históricos.
                Actividades grupales.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t-2 border-white/10" data-id="element-185">
                <span className="text-gray-500 text-[9px] md:text-[10px] line-through font-bold" data-id="element-186">
                  Valor $8.500
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest" data-id="element-187">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="relative bg-[#111633] rounded-lg border-2 border-[#1e2a5a] overflow-hidden p-2.5 md:p-4 flex flex-col" data-id="element-188">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-189">
                03
              </span>
              <span className="inline-block bg-red-600 text-white text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start" data-id="element-190">
                BONO #03
              </span>
              <div className="text-2xl md:text-3xl mb-1.5" data-id="element-191">🏛️</div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-192">
                Proyectos Históricos para el Aula
              </h3>
              <p className="text-gray-400 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-193">
                Proyectos completos paso a paso. Museo histórico escolar.
                Podcast histórico. Periódico histórico.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t-2 border-white/10" data-id="element-194">
                <span className="text-gray-500 text-[9px] md:text-[10px] line-through font-bold" data-id="element-195">
                  Valor $8.000
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest" data-id="element-196">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 4 */}
            <div className="relative bg-[#111633] rounded-lg border-2 border-[#1e2a5a] overflow-hidden p-2.5 md:p-4 flex flex-col" data-id="element-197">
              <span className="absolute top-1 right-2 text-[30px] md:text-[50px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-198">
                04
              </span>
              <span className="inline-block bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest mb-1.5 self-start" data-id="element-199">
                BONO #04
              </span>
              <div className="text-2xl md:text-3xl mb-1.5" data-id="element-200">📊</div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 uppercase" data-id="element-201">
                Sistema PRO de Evaluación en Historia
              </h3>
              <p className="text-gray-400 text-[10px] md:text-xs font-medium leading-snug flex-1" data-id="element-202">
                Evaluaciones diagnósticas. Rúbricas. Evaluaciones por unidad.
                Trabajos integradores.
              </p>
              <div className="flex items-center justify-between mt-2 pt-2 border-t-2 border-white/10" data-id="element-203">
                <span className="text-gray-500 text-[9px] md:text-[10px] line-through font-bold" data-id="element-204">
                  Valor $8.000
                </span>
                <span className="bg-[#eab308] text-black text-[8px] md:text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest" data-id="element-205">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="max-w-xs mx-auto bg-[#111633] border-2 border-[#1e2a5a] rounded-xl p-3 md:p-4 text-center" data-id="element-206">
            <p className="text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1" data-id="element-207">
              Valor total de los 4 bonus:
            </p>
            <p className="text-white text-lg md:text-xl font-black line-through decoration-red-600 decoration-4 mb-1 md:mb-1.5" data-id="element-208">
              $33.000
            </p>
            <p className="text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-1" data-id="element-209">
              Hoy te los llevás por:
            </p>
            <p className="text-[#eab308] text-3xl md:text-4xl font-black mb-1 md:mb-1.5" data-id="element-210">
              $0
            </p>
            <p className="text-[#eab308] font-black text-[9px] md:text-[10px] uppercase tracking-widest" data-id="element-211">
              ✨ Incluidos GRATIS con tu compra ✨
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #0d1229 0%, #0a0e1a 100%)'
    }} data-id="element-212">
        <div className="max-w-2xl mx-auto text-center" data-id="element-213">
          <h2 className="text-lg md:text-2xl font-black text-[#eab308] mb-3 md:mb-4 uppercase tracking-wider" data-id="element-214">
            El precio de lanzamiento termina en
          </h2>

          <div className="flex items-center justify-center gap-1.5 md:gap-3 mb-3 md:mb-4" data-id="element-215">
            <div className="flex flex-col items-center" data-id="element-216">
              <div className="bg-red-700 border-2 border-red-500 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-217">
                <span className="text-white text-xl md:text-2xl font-black" data-id="element-218">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-219">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-2xl font-black -mt-4" data-id="element-220">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-221">
              <div className="bg-red-700 border-2 border-red-500 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-222">
                <span className="text-white text-xl md:text-2xl font-black" data-id="element-223">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-224">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-xl md:text-2xl font-black -mt-4" data-id="element-225">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-226">
              <div className="bg-red-700 border-2 border-red-500 rounded-lg w-10 h-10 md:w-14 md:h-14 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.4)]" data-id="element-227">
                <span className="text-white text-xl md:text-2xl font-black" data-id="element-228">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-[8px] md:text-[9px] font-black uppercase tracking-widest mt-1" data-id="element-229">
                Segundos
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-1 md:gap-1.5 mb-3 md:mb-4" data-id="element-230">
            <span className="flex items-center gap-1 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-231">
              🔥 Últimas unidades
            </span>
            <span className="flex items-center gap-1 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-232">
              📢 Oferta Lanzamiento
            </span>
            <span className="flex items-center gap-1 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-[9px] md:text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider" data-id="element-233">
              📈 Precio sube al terminar
            </span>
          </div>

          <div className="max-w-sm mx-auto mb-2 md:mb-3" data-id="element-234">
            <div className="relative w-full h-2.5 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-235">
              <div className="h-full rounded-full" style={{
              width: '72%',
              background: 'linear-gradient(90deg, #f97316 0%, #ef4444 60%, #dc2626 100%)'
            }} data-id="element-236" />
            </div>
            <p className="text-gray-400 text-[9px] font-black mt-1 uppercase tracking-widest" data-id="element-237">
              72 % de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 50%, #080c1a 100%)'
    }} data-id="element-238">
        <div className="max-w-4xl mx-auto" data-id="element-239">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 md:mb-5 uppercase" data-id="element-240">
            Elegí tu{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-4" data-id="element-241">
              Pack Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-242" />

          {/* Features Box */}
          <div className="max-w-xl mx-auto bg-[#111633] border-2 border-[#1e2a5a] rounded-xl p-3 md:p-4" data-id="element-243">
            <h3 className="text-white font-black text-xs md:text-sm mb-2 md:mb-3 flex items-center gap-1.5 uppercase tracking-wider" data-id="element-244">
              👑 KIT COMPLETO INCLUYE:
            </h3>
            <ul className="space-y-1 md:space-y-1.5" data-id="element-245">
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-246">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-247" />
                6 tomos de contenidos de historia para todo el año
              </li>
              
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-248">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-249" />
                BONUS: Planificación anual completa de Historia
              </li>
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-250">
                BONUS: actividades de historia
              </li>
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-251">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-252" />
                BONUS: Proyectos históricos para el aula
              </li>
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-253">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-254" />
                BONUS: Sistema PRO de evaluación en Historia
              </li>
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-255">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-256" />
                Entrega inmediata por Drive (PDF)
              </li>
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-257">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-258" />
                Acceso de por vida — sin vencimiento
              </li>
              <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs font-medium" data-id="element-259">
                <Check className="w-3.5 h-3.5 text-[#eab308] flex-shrink-0 mt-0.5" data-id="element-260" />
                Garantía de satisfacción de 7 días
              </li>
            </ul>
          </div>

          <p className="text-center text-gray-500 text-[9px] md:text-[10px] mt-2 md:mt-3 flex items-center justify-center gap-1 font-bold uppercase tracking-widest" data-id="element-261">
            <CreditCard className="w-3 h-3 text-gray-400" data-id="element-262" />
            Transferencia · Mercado Pago · Tarjeta
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="bg-white py-3 md:py-5 px-4" data-id="element-263">
        <div className="max-w-2xl mx-auto text-center" data-id="element-264">
          <h2 className="text-base md:text-lg font-black text-gray-900 mb-2 md:mb-3 uppercase" data-id="element-265">
            🔽 ¿Cómo recibís el{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-2" data-id="element-266">
              material
            </span>
            ?
          </h2>

          <div className="grid grid-cols-3 gap-1.5 md:gap-3" data-id="element-267">
            <div className="relative" data-id="element-268">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-gray-100 rounded-full flex items-center justify-center text-xs md:text-sm font-black text-gray-900 mx-auto mb-1 border-2 border-gray-200" data-id="element-269">
                1
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-gray-900 mb-0.5 uppercase" data-id="element-270">
                Comprás
              </h3>
              <p className="text-gray-600 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-271">
                Ingresás tu correo.
              </p>
            </div>
            <div className="relative" data-id="element-272">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-gray-100 rounded-full flex items-center justify-center text-xs md:text-sm font-black text-gray-900 mx-auto mb-1 border-2 border-gray-200" data-id="element-273">
                2
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-gray-900 mb-0.5 uppercase" data-id="element-274">
                Pagás
              </h3>
              <p className="text-gray-600 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-275">
                Pago seguro.
              </p>
            </div>
            <div className="relative" data-id="element-276">
              <div className="w-6 h-6 md:w-8 md:h-8 bg-gray-100 rounded-full flex items-center justify-center text-xs md:text-sm font-black text-gray-900 mx-auto mb-1 border-2 border-gray-200" data-id="element-277">
                3
              </div>
              <h3 className="text-[9px] md:text-[11px] font-black text-gray-900 mb-0.5 uppercase" data-id="element-278">
                Descargás
              </h3>
              <p className="text-gray-600 text-[8px] md:text-[10px] font-medium leading-tight" data-id="element-279">
                Recibís el link.
              </p>
            </div>
          </div>

          <div className="mt-2 bg-yellow-50 border-2 border-yellow-200 rounded-lg p-1.5 inline-block" data-id="element-280">
            <p className="text-yellow-800 flex items-center justify-center gap-1 font-bold text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-281">
              <AlertTriangle className="w-3 h-3" data-id="element-282" />
              Si no lo ves en tu bandeja, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="bg-white py-3 md:py-5 px-4 border-t-2 border-gray-100" data-id="element-283">
        <div className="max-w-2xl mx-auto text-center" data-id="element-284">
          <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-[#eab308] mx-auto mb-1.5 md:mb-2" data-id="element-285" />
          <h2 className="text-lg md:text-xl font-black text-gray-900 mb-1 uppercase" data-id="element-286">
            Garantía de{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-2" data-id="element-287">
              Satisfacción Total
            </span>
          </h2>
          <p className="text-xs md:text-sm text-gray-600 font-medium" data-id="element-288">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="bg-gray-50 py-4 md:py-6 px-4 border-t-2 border-gray-200" data-id="element-289">
        <div className="max-w-4xl mx-auto" data-id="element-290">
          <h2 className="text-xl md:text-3xl font-black text-center text-gray-900 mb-3 md:mb-5 uppercase" data-id="element-291">
            <span className="text-[#eab308]" data-id="element-292">Testimonios</span> de Docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-293">
            <div className="bg-white p-3 rounded-xl shadow-sm border-2 border-gray-100" data-id="element-294">
              <div className="flex gap-0.5 text-[#eab308] mb-1.5" data-id="element-295">
                <Star className="w-3 h-3 fill-current" data-id="element-296" />
                <Star className="w-3 h-3 fill-current" data-id="element-297" />
                <Star className="w-3 h-3 fill-current" data-id="element-298" />
                <Star className="w-3 h-3 fill-current" data-id="element-299" />
                <Star className="w-3 h-3 fill-current" data-id="element-300" />
              </div>
              <p className="text-gray-700 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-301">
                "Arranqué el año sin nada armado para Historia y con este kit en
                una tarde ya tenía todo planificado. Las actividades con fuentes
                históricas son increíbles y los chicos se enganchan al toque. Me
                salvó literalmente el cuatrimestre."
              </p>
              <div className="font-black text-gray-900 text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-302">
                Soledad M., 34 años –{' '}
                <span className="text-gray-500 font-bold" data-id="element-303">
                  La Plata, Buenos Aires
                </span>
              </div>
            </div>

            <div className="bg-white p-3 rounded-xl shadow-sm border-2 border-gray-100" data-id="element-304">
              <div className="flex gap-0.5 text-[#eab308] mb-1.5" data-id="element-305">
                <Star className="w-3 h-3 fill-current" data-id="element-306" />
                <Star className="w-3 h-3 fill-current" data-id="element-307" />
                <Star className="w-3 h-3 fill-current" data-id="element-308" />
                <Star className="w-3 h-3 fill-current" data-id="element-309" />
                <Star className="w-3 h-3 fill-current" data-id="element-310" />
              </div>
              <p className="text-gray-700 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-311">
                "Doy Historia en dos escuelas y siempre me costaba encontrar
                material que no fuera universitario. Este kit está pensado para
                secundaria de verdad. Las líneas de tiempo y los análisis de
                fuentes son excelentes. Las rúbricas me facilitan la
                corrección."
              </p>
              <div className="font-black text-gray-900 text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-312">
                Ricardo G., 41 años –{' '}
                <span className="text-gray-500 font-bold" data-id="element-313">
                  Rosario, Santa Fe
                </span>
              </div>
            </div>

            <div className="bg-white p-3 rounded-xl shadow-sm border-2 border-gray-100" data-id="element-314">
              <div className="flex gap-0.5 text-[#eab308] mb-1.5" data-id="element-315">
                <Star className="w-3 h-3 fill-current" data-id="element-316" />
                <Star className="w-3 h-3 fill-current" data-id="element-317" />
                <Star className="w-3 h-3 fill-current" data-id="element-318" />
                <Star className="w-3 h-3 fill-current" data-id="element-319" />
                <Star className="w-3 h-3 fill-current" data-id="element-320" />
              </div>
              <p className="text-gray-700 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-321">
                "Lo que más me gustó es el Tomo 6 de Historia Argentina. Mis
                alumnos armaron proyectos sobre procesos de independencia y fue
                la mejor experiencia del año. Los directivos quedaron
                impresionados con las presentaciones."
              </p>
              <div className="font-black text-gray-900 text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-322">
                Claudia V., 39 años –{' '}
                <span className="text-gray-500 font-bold" data-id="element-323">Córdoba Capital</span>
              </div>
            </div>

            <div className="bg-white p-3 rounded-xl shadow-sm border-2 border-gray-100" data-id="element-324">
              <div className="flex gap-0.5 text-[#eab308] mb-1.5" data-id="element-325">
                <Star className="w-3 h-3 fill-current" data-id="element-326" />
                <Star className="w-3 h-3 fill-current" data-id="element-327" />
                <Star className="w-3 h-3 fill-current" data-id="element-328" />
                <Star className="w-3 h-3 fill-current" data-id="element-329" />
                <Star className="w-3 h-3 fill-current" data-id="element-330" />
              </div>
              <p className="text-gray-700 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-331">
                "Soy docente hace 15 años y nunca encontré un material tan
                completo para Historia. Antes perdía fines de semana enteros
                armando clases. Ahora abro el PDF, imprimo y listo. La
                planificación anual que viene de bonus es un golazo."
              </p>
              <div className="font-black text-gray-900 text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-332">
                Alejandro D., 47 años –{' '}
                <span className="text-gray-500 font-bold" data-id="element-333">
                  San Miguel de Tucumán
                </span>
              </div>
            </div>

            <div className="bg-white p-3 rounded-xl shadow-sm border-2 border-gray-100" data-id="element-334">
              <div className="flex gap-0.5 text-[#eab308] mb-1.5" data-id="element-335">
                <Star className="w-3 h-3 fill-current" data-id="element-336" />
                <Star className="w-3 h-3 fill-current" data-id="element-337" />
                <Star className="w-3 h-3 fill-current" data-id="element-338" />
                <Star className="w-3 h-3 fill-current" data-id="element-339" />
                <Star className="w-3 h-3 fill-current" data-id="element-340" />
              </div>
              <p className="text-gray-700 text-[10px] md:text-xs mb-1.5 italic font-medium leading-snug" data-id="element-341">
                "Mis alumnos siempre se dormían en clase de Historia. Con las
                actividades de análisis de fuentes reales y los debates
                históricos ahora se enganchan solos. El material de Edad Media y
                Mundo Antiguo les fascina porque lo conectan con películas y
                series que ven."
              </p>
              <div className="font-black text-gray-900 text-[9px] md:text-[10px] uppercase tracking-wider" data-id="element-342">
                Natalia P., 36 años –{' '}
                <span className="text-gray-500 font-bold" data-id="element-343">Mendoza</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-4 md:py-6 px-4" data-id="element-344">
        <div className="max-w-2xl mx-auto" data-id="element-345">
          <h2 className="text-xl md:text-2xl font-black text-center text-gray-900 mb-3 md:mb-4 uppercase" data-id="element-346">
            Preguntas{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-2" data-id="element-347">
              Frecuentes
            </span>
          </h2>

          <div className="space-y-1 md:space-y-1.5" data-id="element-348">
            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-349">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-350">
                ¿En qué formato recibo el material?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-351" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-352">
                Todo el material viene en formato PDF, listo para descargar,
                imprimir o usar de forma digital en cualquier dispositivo.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-353">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-354">
                ¿Cuánto tarda en llegar después de pagar?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-355" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-356">
                El acceso es inmediato. Apenas completás el pago, recibís el
                link de descarga en tu correo electrónico. Si no lo ves en la
                bandeja de entrada, revisá la carpeta de spam.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-357">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-358">
                ¿Puedo imprimir el material y usarlo en varias divisiones?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-359" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-360">
                Sí, podés imprimirlo todas las veces que necesites y usarlo en
                todas las divisiones y cursos donde des la materia. El acceso es
                de por vida.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-361">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-362">
                ¿Está alineado a los NAP 2026?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-363" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-364">
                Sí, el kit está 100% alineado a los Núcleos de Aprendizajes
                Prioritarios 2026 para Historia. Podés presentar la
                planificación ante directivos con total confianza.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-365">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-366">
                ¿Qué pasa si no me sirve o no es lo que esperaba?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-367" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-368">
                Tenés 7 días de garantía total. Si el material no cumple tus
                expectativas por cualquier motivo, te devolvemos el 100% de tu
                dinero sin hacerte ninguna pregunta.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-369">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-370">
                ¿Para qué año de secundaria sirve?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-371" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-372">
                Sirve para todos los años donde se dicte Historia en secundaria.
                El contenido es adaptable y cubre desde pensamiento histórico
                hasta historia argentina y latinoamericana.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-373">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-374">
                No tengo tarjeta de crédito, ¿puedo pagar de otra forma?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-375" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-376">
                Sí, aceptamos múltiples medios de pago: transferencia bancaria,
                Mercado Pago, tarjeta de débito y tarjeta de crédito. Elegí el
                que te resulte más cómodo.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-377">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-378">
                ¿Incluye planificación anual lista para presentar?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-379" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-380">
                Sí, como bonus incluimos una planificación anual completa de
                Historia con objetivos, contenidos por unidad, actividades
                sugeridas y criterios de evaluación. Lista para presentar ante
                directivos sin modificar nada.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-381">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-382">
                ¿Sirve si ya empecé el año y necesito material urgente?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-383" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-384">
                ¡Sí! Muchos docentes lo compran a mitad de año. El material está
                organizado por tomos temáticos, así que podés empezar por el
                tema que necesites sin seguir un orden fijo. Lo descargás al
                instante y lo usás en tu próxima clase.
              </div>
            </details>

            <details className="group bg-gray-50 rounded-lg border-2 border-gray-200 open:bg-white open:shadow-sm transition-all duration-200" data-id="element-385">
              <summary className="flex items-center justify-between cursor-pointer p-2.5 md:p-3 text-xs md:text-sm font-black text-gray-900 list-none uppercase" data-id="element-386">
                ¿Qué diferencia hay entre el pack de $19.990 y el de $27.990?
                <ChevronDown className="w-4 h-4 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-387" />
              </summary>
              <div className="px-2.5 pb-2.5 md:px-3 md:pb-3 text-[10px] md:text-xs text-gray-700 font-medium leading-snug border-t-2 border-gray-100 pt-2" data-id="element-388">
                El pack de $19.990 incluye los 6 tomos de Historia con todos los
                bonus. El pack de $27.990 incluye todo eso más el Sistema de
                Proyectos Históricos para el Aula, ideal si querés que tus
                alumnos desarrollen proyectos completos como museos escolares,
                podcasts y periódicos históricos.
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* BOTTOM PRICING (Replicated) */}
      <section className="py-4 md:py-6 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 50%, #080c1a 100%)'
    }} data-id="element-389">
        <div className="max-w-4xl mx-auto" data-id="element-390">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-3 md:mb-5 uppercase" data-id="element-391">
            Elegí tu{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-4" data-id="element-392">
              Pack Completo
            </span>
          </h2>

          <PricingGrid selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-393" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="bg-black text-white py-4 md:py-6 px-4 text-center" data-id="element-394">
        <div className="max-w-3xl mx-auto" data-id="element-395">
          <h2 className="text-xl md:text-3xl font-black mb-1 md:mb-2 uppercase" data-id="element-396">
            ¿Listo/a para{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-4" data-id="element-397">
              transformar tu año
            </span>{' '}
            en Historia?
          </h2>
          <p className="text-xs md:text-sm text-gray-400 mb-2 md:mb-4 font-bold uppercase tracking-wider" data-id="element-398">
            Sumate a los más de 3.000 docentes que ya dejaron de improvisar.
          </p>

          <p className="text-gray-500 font-black uppercase tracking-widest text-[9px] md:text-[10px]" data-id="element-399">
            📈 KIT COMPLETO HISTORIA LISTA
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="bg-gray-900 py-2 md:py-3 px-4 text-center border-t-2 border-gray-800" data-id="element-400">
        <p className="text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-401">
          ¿Tenés dudas? Escribinos a{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-[#eab308] font-black hover:underline" data-id="element-402">
            kitonline27@gmail.com
          </a>
        </p>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-500 py-3 md:py-4 px-4 text-center text-[9px] md:text-[10px] border-t-2 border-gray-800 font-bold uppercase tracking-widest" data-id="element-403">
        <p className="mb-1.5 md:mb-2" data-id="element-404">© 2026 Kit Completo Historia Lista™</p>
        <div className="flex justify-center gap-3 md:gap-4" data-id="element-405">
          <span className="hover:text-white cursor-pointer" data-id="element-406">Términos</span>
          <span className="hover:text-white cursor-pointer" data-id="element-407">Privacidad</span>
          <span className="hover:text-white cursor-pointer" data-id="element-408">Soporte</span>
        </div>
      </footer>
    </div>;
}